import React, { useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, ShieldCheck, Car, HeartPulse, Factory, ShoppingCart, Cpu, Megaphone, Rocket } from "lucide-react";
import { industries, solutions } from "../mock";

const iconMap = { ShieldCheck, Car, HeartPulse, Factory, ShoppingCart, Cpu, Megaphone, Rocket };

const IndustryDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const industry = industries.find((i) => i.slug === slug);

  useEffect(() => window.scrollTo(0, 0), [slug]);

  if (!industry) {
    return (
      <div className="min-h-screen bg-[#050f24] flex flex-col items-center justify-center text-white gap-6">
        <h1 className="text-4xl font-bold" style={{ fontFamily: "Archivo, sans-serif" }}>Industry not found</h1>
        <Link to="/" className="text-white inline-flex items-center gap-2"><ArrowLeft size={16} /> Back to home</Link>
      </div>
    );
  }

  const Icon = iconMap[industry.icon];

  return (
    <main className="bg-[#050f24] min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute -right-40 -top-20 w-[600px] h-[600px] rounded-full bg-blue-600/12 blur-3xl" />
        <div className="absolute -left-32 bottom-0 w-[400px] h-[400px] rounded-full bg-white/8 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="w-16 h-16 rounded-2xl bg-white/12 flex items-center justify-center mb-8 inline-flex">
            <Icon size={32} className="text-white" strokeWidth={1.6} />
          </span>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-bold max-w-3xl leading-[1.08]" style={{ fontFamily: "Archivo, sans-serif" }}>
            {industry.name}
          </h1>
          <p className="text-white/70 text-xl leading-relaxed mt-6 max-w-2xl">{industry.blurb}</p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <div className="bg-[#0b2044] border border-white/10 rounded-2xl p-8 lg:p-12 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-white text-2xl lg:text-3xl font-bold mb-4" style={{ fontFamily: "Archivo, sans-serif" }}>
              Technology built for {industry.name.toLowerCase()}
            </h2>
            <p className="text-white/70 leading-relaxed">
              ZoofyTechX combines deep domain knowledge with our full solution stack — infrastructure, cloud, security,
              data and managed services — to solve the specific challenges of the {industry.name.toLowerCase()} sector.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            {solutions.slice(0, 6).map((s) => (
              <button
                key={s.slug}
                onClick={() => navigate(`/solutions/${s.slug}`)}
                className="border border-white/15 hover:border-white/60 hover:text-white text-white/80 text-sm px-4 py-2 rounded-full transition-colors"
              >
                {s.title}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate("/contact")}
            className="inline-flex items-center gap-2 bg-white hover:bg-[#d7e3f4] text-[#04122e] text-sm font-bold px-8 py-3 rounded-full transition-colors"
          >
            Discuss Your Project <ArrowRight size={16} />
          </button>
        </div>
      </section>
    </main>
  );
};

export default IndustryDetail;
